import { render, staticRenderFns } from "./AreaEditor.vue?vue&type=template&id=20e0f69a&scoped=true"
import script from "./AreaEditor.vue?vue&type=script&lang=js"
export * from "./AreaEditor.vue?vue&type=script&lang=js"
import style0 from "./AreaEditor.vue?vue&type=style&index=0&id=20e0f69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e0f69a",
  null
  
)

export default component.exports